import { render } from "./UpdateOrderModal.vue?vue&type=template&id=9c0edb22&scoped=true"
import script from "./UpdateOrderModal.vue?vue&type=script&lang=js"
export * from "./UpdateOrderModal.vue?vue&type=script&lang=js"

import "./UpdateOrderModal.vue?vue&type=style&index=0&id=9c0edb22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c0edb22"]])

export default __exports__